export default __webpack_public_path__ + "static/media/PO0131005_WF_BRAND_2HFY24_ISF_NovUpdate15_LP_1164x584.7e0037d4.jpg";